<div class="container mx-auto md:text-base text-sm text-center">
  <div class="mt-8">
    <h1 class="font-['Apex_Rounded_Medium'] lg:text-3xl text-xl">{{ "forbidden" | translate }}</h1>
  </div>
  <div class="flex">
    <img src="assets/ACP-Error-bot_warning.webp" alt="Image of a sad face" class="mx-auto w-full sm:w-1/2" />
  </div>
</div>
